exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itb-error-message{font-size:80%;color:#f04124;margin-bottom:4px}.itb-label-error{color:#f04124}.itb-field-error{border-color:#f79483;color:#f04124}", ""]);

// exports
